import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { SKIP_CUSTOM_HEADERS } from '@customer-portal/core';
import { UserRoleService } from '@customer-portal/data-access/settings';
import { environment } from '@customer-portal/environments';

export const customHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_CUSTOM_HEADERS)) {
    return next(req);
  }

  const userRoleService = inject(UserRoleService);

  const shouldAddAccountDnvId = userRoleService.shouldRestrictFeatures();
  const accountDnvId = userRoleService.getSelectedCoBrowsingCompanyId();

  const headers: Record<string, string> = {
    'Ocp-Apim-Subscription-Key': environment.apimKey,
  };

  if (shouldAddAccountDnvId && accountDnvId) {
    headers['X-Account-Dnv-Id'] = accountDnvId;
  }

  const modifiedReq = req.clone({
    setHeaders: headers,
    withCredentials: true,
  });

  return next(modifiedReq);
};
